import { History } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ActionHistoryPage } from './pages/ActionHistoryPage'

/**
 * Action History — M9 DataView. Audit log of CARLA actions against
 * Odoo. No badge (observational, not actionable). Replaces
 * reports.siliconesplus.com/actions.
 */
export default defineModule({
  id: 'action-history',
  name: 'Action History',
  shortName: 'Actions',
  icon: History,
  // Sprint 13a (2026-04-26 D-1): action history is cross-cutting —
  // moved from `ops` to `admin` so it sits next to other observational
  // / admin surfaces (CARLA, Settings).
  navSection: 'admin',
  navOrder: 20,
  // Sprint 13a default-collapsed (D-5a): Viewer is a read-only
  // observer. The audit log is investigative, not daily — default-
  // collapse the Admin section for viewers (the only Admin module
  // they see; admin/operations roles keep it expanded).
  navCollapsedForRoles: ['viewer'],
  urlNamespace: '/actions',
  routes: [{ path: '/', element: ActionHistoryPage, label: 'Action History' }],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'viewer'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g a',

  commandPaletteEntries: [
    {
      label: 'Go to Action History',
      keywords: ['actions', 'audit', 'history', 'carla', 'log'],
      path: '/',
      group: 'modules',
      shortcut: 'g a',
    },
  ],
})
